import { useState, useEffect } from 'react';

export default function EasterEgg() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Alt + P
      if (e.altKey && e.key === 'p') {
        e.preventDefault();
        setShow(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleClose = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      onClick={handleClose}
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm cursor-pointer animate-in fade-in duration-300"
      style={{ isolation: 'isolate' }}
    >
      <div className="relative max-w-4xl max-h-[90vh] p-4">
        <img
          src="/easter-egg.png"
          alt=""
          className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl animate-in zoom-in duration-500"
          onClick={handleClose}
        />
        <div className="absolute top-8 right-8 text-white/60 text-sm animate-pulse">
          Click anywhere to close
        </div>
      </div>
    </div>
  );
}
